
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import Icon from '../assets/icons';
import { SidePanelTabs } from '../components/shared';
import { ITabs, Tabs } from '../components/tabs';
import CollectedCardList from '../components/visiting-card/CollectedCardList';
import VistingCardPanel from '../components/visiting-card/VisitingCardPanel';
import Tab from '../interfaces/Tab';
import { AppPage } from '../layouts/types';

type ScreenSize = {
  winWidth: number;
  winHeight: number;
};

export const CollectedVisitingCard: AppPage = () => {
  const router = useNavigate();
  const [searchParams] = useSearchParams();

  const name = searchParams.get("name");
  const date = searchParams.get("date");
  const count = searchParams.get("count");
  const profileImage = searchParams.get("profileImage");

  const sessionList = useMemo(() => {
    const raw = searchParams.get("sessionList");
    try {
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.error("Failed to parse sessionList:", e);
      return null;
    }
  }, [searchParams]);
  const [activeTab, setActiveTab] = useState("collected-card");

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };


  const [screenWidth, setScreenWidth] = useState<ScreenSize>({
    winWidth: 0,
    winHeight: 0,
  });


  const windowSize = () => {
    setScreenWidth({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };


  useEffect(() => {
    windowSize();
    window.addEventListener("resize", windowSize);

    return () => {
      window.removeEventListener("resize", windowSize);
    };
  }, []);



  const tabData: ITabs = {
    "Your Visiting Card ": [
      {
        id: 1,

        TabContent: <VistingCardPanel></VistingCardPanel>,
      },
    ],
    "Collected Visiting Cards": [
      {
        id: 2,
        TabContent: (
          <CollectedCardList
            sessionList={JSON.parse(sessionList)}
            name={name}
            date={date}
            count={count}
            profileImage={profileImage}
          />
        ),
      },
    ],
  };

  const sideBarData: Tab[] = [
    {
      id: "visiting-card",
      label: "Your Visiting Card ",
      icon: <img src={Icon.yourCard} alt="vCard" width={30} height={30} />,
      content: <VistingCardPanel></VistingCardPanel>,
    },
    {
      id: "collected-card",
      label: "Collected Visiting Cards",
      icon: (
        <img src={Icon.collectedCard} alt="vCard" width={30} height={30} />
      ),
      content: (
        <CollectedCardList
          sessionList={JSON.parse(sessionList)}
          name={name}
          date={date}
          count={count}
          profileImage={profileImage}
        />
      ),
    },
  ];

  return (
    <>
      <div className="h-full">
        {screenWidth.winWidth < 768 ? (
          <Tabs data={tabData}></Tabs>
        ) : (
          <SidePanelTabs
            handleTabClick={handleTabClick}
            activeTab={activeTab}
            tabs={sideBarData}
            title="Visiting Card"
          />
        )}
      </div>
    </>
  );
};

export default CollectedVisitingCard;